import React from 'react';
import { MenuGroup } from '@atlaskit/menu';
import { Stack } from '@atlaskit/primitives';
import { useAutomationMenu } from '../../menu-context';
import { AutomationModalEmptyState } from '../empty-state';
import { AutomationModalRule } from '../rule';
export var AutomationModalRuleListOld = function AutomationModalRuleListOld(_ref) {
  var selectedRule = _ref.selectedRule,
    setSelectedRule = _ref.setSelectedRule;
  var _useAutomationMenu = useAutomationMenu(),
    rules = _useAutomationMenu.rules;
  if (rules.length === 0) {
    return /*#__PURE__*/React.createElement(AutomationModalEmptyState, null);
  }
  return /*#__PURE__*/React.createElement(MenuGroup, null, /*#__PURE__*/React.createElement(Stack, {
    space: "space.050"
  }, rules.map(function (rule) {
    return /*#__PURE__*/React.createElement(AutomationModalRule, {
      key: "manual-rule-".concat(rule.id),
      rule: rule,
      selectedRule: selectedRule,
      setSelectedRule: setSelectedRule
    });
  })));
};